import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import LogoLR from "../images/logolr.png";
import LogoFGML from "../images/logofgml.png";
import LogoMinedu from "../images/logominedu.png";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

const Footer = () => {
  const useStyles = makeStyles((theme) => ({
    lr: {
      width: 158,
    },
    fgml: {
      height: 70,
    },
    minedu: {
      width: 240,
    },
    logos: {
      "& img": {
        marginLeft: 5,
        padding: 16,
      },
      marginTop: "1em",
      marginBottom: "1em",
    },
  }));
  const classes = useStyles();
  return (
    <footer>
      <Divider />
      <Grid
        container
        className={classes.logos}
        alignItems="center"
        justify="center"
      >
        <a
          href="https://larepublica.pe/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img className={classes.lr} src={LogoLR} alt="Grupo La República" />
        </a>

        <a
          href="https://fundacionmohme.org/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            className={classes.fgml}
            src={LogoFGML}
            alt="Fundación Gustavo Mohme Llona"
          />
        </a>
        <a
          href="https://aprendoencasa.pe/#/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <img
            className={classes.minedu}
            src={LogoMinedu}
            alt="Ministerio de educación"
          />
        </a>
      </Grid>
    </footer>
  );
};

export default Footer;
